var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSub02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 6.92857C17.1426 3.37817 20.0207 0.5 23.5711 0.5H47.1426C50.6929 0.5 53.5711 3.37817 53.5711 6.92857V43.3571C53.5711 46.9074 50.6929 49.7857 47.1426 49.7857H23.5711C20.0207 49.7857 17.1426 46.9074 17.1426 43.3571V6.92857Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42773 17.6424C6.42773 14.092 9.30589 11.2139 12.8563 11.2139H36.4277C39.9781 11.2139 42.8563 14.092 42.8563 17.6424V54.071C42.8563 57.6213 39.9781 60.4996 36.4277 60.4996H12.8563C9.30589 60.4996 6.42773 57.6213 6.42773 54.071V17.6424Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3908 21.9286C13.3908 20.4492 14.5901 19.25 16.0694 19.25H33.2122C34.6916 19.25 35.8908 20.4492 35.8908 21.9286C35.8908 23.4079 34.6916 24.6071 33.2122 24.6071H16.0694C14.5901 24.6071 13.3908 23.4079 13.3908 21.9286ZM13.3929 32.6429C13.3929 31.1635 14.5921 29.9643 16.0715 29.9643H33.2143C34.6937 29.9643 35.8929 31.1635 35.8929 32.6429C35.8929 34.1222 34.6937 35.3214 33.2143 35.3214H16.0715C14.5921 35.3214 13.3929 34.1222 13.3929 32.6429ZM16.0682 40.6786C14.5889 40.6786 13.3896 41.8778 13.3896 43.3571C13.3896 44.8366 14.5889 46.0357 16.0682 46.0357H24.6396C26.119 46.0357 27.3182 44.8366 27.3182 43.3571C27.3182 41.8778 26.119 40.6786 24.6396 40.6786H16.0682Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub02);
export default __webpack_public_path__ + "static/media/sub_02.a12599611aed58c9985f0275ddf71d1b.svg";
export { ForwardRef as ReactComponent };